// Core imports
import * as React from 'react';
import {
  goToHome,
  goToVerify,
  goToDashboard,
  goToSamsungOrderInvoicePortal,
  goToSiteTour
} from 'src/utils/navigation';

// Components imports
import SignIn from 'src/components/SignIn';
import UserUpdateInfo from 'src/components/UserUpdateInfo';
import AccountSwitch from 'src/components/AccountSwitch';
// Models imports Style and misc imports
import './SignInView.scss';
import env from 'src/shared/env';

interface ISignInViewProps {
  login(userId: string, password: string): any;
  shouldSelectAccount: boolean;
  pending: boolean;
  signinFailed: boolean;
  signinError: string;
  t: any;
  isLoggedIn: boolean;
  shouldVerify: boolean;
  shouldUpdateInfo: boolean;
  specialUser: string;
  userData: any;
  isSamsungUser: boolean;
}

class SignInView extends React.Component<ISignInViewProps, any> {
  private enableVerify = parseInt(env.REACT_APP_ENABLE_VERIFY_ACCOUNT, 10);

  private redirectToHome = () => {
    if (
      this.enableVerify &&
      this.props.isLoggedIn &&
      this.props.shouldVerify &&
      !this.props.shouldUpdateInfo
    ) {
      goToVerify();
      return;
    }
    if (
      this.props.isLoggedIn &&
      this.props.isSamsungUser &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      const footerhidden = document.getElementsByClassName('mainfooter')[0]
        ? document
            .getElementsByClassName('mainfooter')[0]
            .setAttribute('style', 'display:none')
        : '';
      goToSamsungOrderInvoicePortal();
      return;
    }
    if (
      this.props.isLoggedIn &&
      this.props.specialUser &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      if(localStorage.getItem('redirectUrl')) {
        goToSiteTour();
      return;
      } else {
        goToDashboard();
      return;
      }
    }
    if (
      this.props.isLoggedIn &&
      !this.props.shouldSelectAccount &&
      !this.props.shouldUpdateInfo
    ) {
      if(localStorage.getItem('redirectUrl')) {
        goToSiteTour();
      } else { 
        goToHome();
      }
    }
  };

  public componentDidMount() {
    this.redirectToHome();
  }

  public componentDidUpdate(prevProps: ISignInViewProps) {
    if (
      this.props.isLoggedIn !== prevProps.isLoggedIn ||
      this.props.shouldUpdateInfo !== prevProps.shouldUpdateInfo
    ) {
      this.redirectToHome();
    }
  }

  public render() {
    if (this.props.shouldSelectAccount === true) {
      return (
        <section id="account-view">
          <AccountSwitch />
        </section>
      );
    } else if (this.props.shouldUpdateInfo && this.props.shouldVerify) {
      return (
        <section id="account-view">
          <UserUpdateInfo />
        </section>
      );
    } else {
      return (
        <section id="account-view">
          <SignIn
            login={this.props.login}
            pending={this.props.pending}
            signinFailed={this.props.signinFailed}
            signinError={this.props.signinError}
            isLoggedIn={this.props.isLoggedIn}
            shouldSelectAccount={this.props.shouldSelectAccount}
            shouldVerify={this.props.shouldVerify}
            shouldUpdateInfo={this.props.shouldUpdateInfo}
          />
        </section>
      );
    }
  }
}

export default SignInView;
